import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=a052114c&scoped=true&"
import script from "./servicos.vue?vue&type=script&lang=js&"
export * from "./servicos.vue?vue&type=script&lang=js&"
import style0 from "./servicos.vue?vue&type=style&index=0&id=a052114c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a052114c",
  null
  
)

export default component.exports